<script setup>
import VModal from "@/Shared/VModal.vue";
import { onMounted, ref } from "vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import { useForm } from "@inertiajs/vue3";
import Swal from "sweetalert2";
import VDevider from "@/Shared/VDevider.vue";

const props = defineProps({
    type: String,
    item: Object,
    roles: Array,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);
const form = useForm({});
const isShowApproval = ref(false);

const title = "Attachment";

const cancel = () => {
    emits("onCancel");
};

onMounted(() => {
    isShowApproval.value = props.item.transaction.status != 1;
});

const submit = async () => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Apakah anda yakin?",
        text: "Approve pendaftaran ini!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Approve!",
        cancelButtonText: "Tidak",
    });

    if (!result.isConfirmed) {
        return false;
    }

    form.post(props.item.url_approve, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            emits("onSave");
            refModal.value.closeModal();
        },
        onError: () => {
            console.log("error");
        },
    });
};
</script>
<template>
    <VModal ref="refModal" :title="title" size="modal-lg" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <h5>List Dokumen</h5>
                <VDevider />
                <div class="list-group mb-4">
                    <a
                        v-for="document in item.documents"
                        :href="document.url"
                        target="_blank"
                        class="list-group-item list-group-item-action"
                    >
                        <div class="d-flex">
                            <div class="me-2">
                                <i
                                    class="fa fa-check text-success"
                                    v-if="document.status == 1"
                                ></i>
                                <i
                                    class="fa fa-clock text-secondary"
                                    v-else
                                ></i>
                            </div>
                            <div class="d-grow-1">
                                {{ document.name }}
                            </div>
                        </div>
                    </a>
                </div>

                <h5>Bukti Pembayaran</h5>
                <VDevider />
                <div class="mb-4">
                    <img
                        v-if="item.payment_file"
                        :src="item.payment_file"
                        alt="bukti pembayaran"
                        class="w-100"
                    />
                </div>

                <h5 v-if="item.attachment.length > 0">Lampiran</h5>
                <VDevider v-if="item.attachment.length > 0" />

                <div v-for="image in item.attachment" class="mb-2">
                    <span>{{ image.name }}</span>
                    <img :src="image.file" :alt="image.name" class="w-100" />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div v-if="isShowApproval" class="text-end">
                <VButtonSubmit
                    type="submit"
                    :isProcessing="form.processing"
                    @onCLickSubmit="submit"
                >
                    Approve
                </VButtonSubmit>
            </div>
        </template>
    </VModal>
</template>
